// extracted by mini-css-extract-plugin
module.exports = {"body":"blog_body__h4HSZ","footer":"blog_footer__EMlNW","thumbnail":"blog_thumbnail__QCJVZ","title":"blog_title__J3hAy","blog":"blog_blog__99vXo"};